export enum CountryTypes {
  EN = 'en_gb',
  PL = 'pl_pl',
  DK = 'da_dk',
  SE = 'sv_se',
  DE = 'de_de',
}
